import moment from "moment";
import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import { useState } from "react";
import { Button, Spinner, Toast } from "react-bootstrap";
import { VoucherStore } from "../../stores/VoucherStore";
import { VoucherHistory, voucherState, voucherType } from "../../models/voucher";

type Props = {
    voucherStore: VoucherStore,
    h: VoucherHistory
}

const VoucherHistoryRow: React.FC<Props> = observer(({ voucherStore, h }: Props) => {
    const [isLoadingHistory, setLoadingHistory] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const resendVoucher = async (id: string) => {
      setLoadingHistory(true);
      await voucherStore.resendVoucher(id);
      setAlertMessage('Voucher re-inviato');
      setOpenAlert(true);
      setLoadingHistory(false);
    }
    const cancelVoucher = async (id: string) => {
      setLoadingHistory(true);
      await voucherStore.cancelVoucher(id);
      setAlertMessage('Voucher annullato');
      setOpenAlert(true);
      setLoadingHistory(false);
    }
    return (     
      <>
        {isLoadingHistory ? 
        (<div className='row history-loading' key={h.voucherId}>
          <Spinner key={h.voucherId} animation="grow" size="sm" />
        </div>) :
        (<div className='row' key={h.voucherId}>
          <div className='col col-sm-1'>{moment(h.lastSendDate).format('L')}</div>
          <div className='col col-sm-2'>{h.mail}</div>
          <div className='col col-sm-1'>{_.findKey(voucherType, v => v === h.type)}</div>
          <div className='col col-sm-1'>{h.ndg}</div>
          <div className='col col-sm-1'>{h.taxCode || h.vatCode}</div>
          <div className='col col-sm-1'>{moment(h.voucherExpireDate).format('L')}</div>
          <div className='col col-sm-1'>{_.find(voucherState,(v,k) => k === h.voucherState)}</div>
          <div className='col col-sm-1'>{h.voucherRegisteredStartDate && moment(h.voucherRegisteredStartDate).format('L')}</div>
          <div className='col col-sm-1'>{h.voucherRegisteredEndDate && moment(h.voucherRegisteredEndDate).format('L')}</div>
          {h.voucherState === 'Sended' && (<div className='col col-sm-1'><Button key={h.voucherId} onClick={() => resendVoucher(h.voucherId)} disabled={isLoadingHistory}>reinvia</Button></div>)}
          {h.voucherState === 'Sended' && (<div className='col col-sm-1'><Button key={h.voucherId} onClick={() => cancelVoucher(h.voucherId)} disabled={isLoadingHistory}>annulla</Button></div>)}
        </div>)}
        <div className="alert-row">
          <Toast
            className="d-inline-block m-1"
            bg={voucherStore.historyActionResult.error ? "danger" : "success"}
            key={alertMessage}
            show={openAlert}
            autohide={true}
            onClose={() => setOpenAlert(false)}
          >
            <Toast.Header>
              <strong className="me-auto">Storico Voucher</strong>
            </Toast.Header>
            <Toast.Body>
              {voucherStore.historyActionResult.error ? "Errore nella richiesta" : alertMessage}
            </Toast.Body>
          </Toast>
        </div>
      </>
    );
})

export default VoucherHistoryRow;